@let formName =
  'edit' +
  information.type[0].toUpperCase() +
  information.type.substring(1) +
  'Form';

<form
  [formGroup]="editForm"
  (ngSubmit)="onSubmit()"
  [name]="formName"
  [ngClass]="{
    'edit-xSmall': (xSmallScreen$ | async),
    'edit-small': (smallScreen$ | async),
    'edit-medium': (mediumScreen$ | async),
    'edit-large': (largeScreen$ | async),
    'edit-xLarge': (xLargeScreen$ | async),
    editGpsOnlyForm: information.type === 'mapmode',
    editScenicForm: information.type === 'scenic',
    editWorkoutForm: information.type === 'workout',
    editCoachingForm: information.type === 'coaching',
  }">
  @switch (information.type) {
    @case ('scenic') {
      <!-- VIDEO TITLE -->
      <div class="input name">
        <label for="title">
          {{ 'sharing.editComponent.label.video_name' | translate }}
        </label>
        <input formControlName="title" type="text" />
      </div>

      <!-- STATUS -->
      <div class="select status">
        <span class="icon icon-arrow-right"></span>
        <label for="status">
          {{ 'sharing.editComponent.label.status' | translate }}
        </label>
        <select formControlName="status" name="status" id="">
          <option value="public">
            {{ 'settings.confidentiality.public' | translate }}
          </option>
          <option value="private">
            {{ 'settings.confidentiality.private' | translate }}
          </option>
        </select>
      </div>

      <!-- DESCRIPION -->
      <div class="text-area description">
        <label for="">
          {{ 'sharing.editComponent.label.description' | translate }}
        </label>
        <ckeditor
          class="ckdata"
          formControlName="description"
          [editor]="editor"
          [config]="config" />
      </div>

      <div class="select vehicule">
        <span class="icon icon-arrow-right"></span>
        <label for="vehicule_id">
          {{ 'sharing.editComponent.label.vehicule' | translate }}
        </label>
        <select formControlName="vehicule_id" name="vehicule_id">
          <option class="placeholder" [value]="null">
            {{ 'sharing.editComponent.select.not_specified' | translate }}
          </option>
          @for (vehicule of vehicules; track $index) {
            <option [value]="vehicule.id">
              {{ vehicule.name }}
            </option>
          }
        </select>
      </div>

      <!-- recommended_mode -->
      <div class="select reco-mode">
        <span class="icon icon-arrow-right"></span>
        <label for="recommended_mode">
          {{ 'sharing.editComponent.label.recommended_mode' | translate }}
          <span class="info">
            <img src="assets/images/svg/information.svg" alt="info" />
            <span class="tooltip">
              {{ 'editScenic.tooltip.recomended_mode' | translate }}
              <a
                href="https://support.kinomap.com/hc/fr/articles/115000357003-Les-modes-Vitesse-Originale-et-Vitesse-Variable"
                >{{ 'editScenic.tooltip.more_information_here' | translate }}</a
              >
            </span>
          </span>
        </label>
        <select
          formControlName="recommended_mode"
          name="recommended_mode"
          id="recommended_mode">
          <option class="placeholder" value="null">
            {{ 'sharing.editComponent.select.not_specified' | translate }}
          </option>
          <option value="discovery">
            {{ 'dashboard.timeline.activity.mode.discovery' | translate }}
          </option>
          <option value="challenge">
            {{ 'dashboard.timeline.activity.mode.challenge' | translate }}
          </option>
        </select>
      </div>

      <div class="select reco-audio">
        <span class="icon icon-arrow-right"></span>
        <label for="recommended_audio">
          {{ 'sharing.editComponent.label.recommended_audio' | translate }}
          <span class="info">
            <img src="assets/images/svg/information.svg" alt="info" />
            <span class="tooltip">{{
              'editScenic.tooltip.recomended_audio' | translate
            }}</span>
          </span>
        </label>
        <select formControlName="recommended_audio" name="" id="">
          <option class="placeholder" [value]="'null'">
            {{ 'sharing.editComponent.select.not_specified' | translate }}
          </option>
          <option value="remove">
            {{
              'sharing.editComponent.select.recommended_audio.remove'
                | translate
            }}
          </option>
          <option value="keep">
            {{
              'sharing.editComponent.select.recommended_audio.keep' | translate
            }}
          </option>
          <option value="force">
            {{
              'sharing.editComponent.select.recommended_audio.force' | translate
            }}
          </option>
        </select>
      </div>

      <div class="tags-block">
        <label for="">{{
          'sharing.editComponent.label.tags' | translate
        }}</label>

        <div class="tags-wrapper" [style.paddingRight]="'3.5rem'">
          <span pRipple class="arrow-block" (click)="editTags = !editTags">
            <span
              [ngClass]="editTags ? 'icon-top' : 'icon-bot'"
              class="icon icon-arrow-right"></span>
          </span>

          @if (!editTags) {
            <ng-container>
              @for (tag of tags; track $index) {
                <span class="current-tag">
                  {{ tag.name | titlecase }}
                </span>
              }
            </ng-container>
          } @else {
            <ng-container>
              @for (tag of tags; track $index) {
                <tag-chip
                  [tag]="tag.name"
                  [primary]="includesTag(tag)"
                  (onClick)="onSelectTagClick(tag)"></tag-chip>
              }
            </ng-container>
          }

          @if (tags.length === 0) {
            <div class="no-tags-available">
              {{ 'sharing.tags.no_tags' | translate }}
            </div>
          }
        </div>

        @if (editTags) {
          <div class="tags-wrapper">
            @if (allTags.length === 0) {
              <div class="no-tags-available">
                {{ 'sharing.tags.all_tags_added' | translate }}
              </div>
            }

            @for (tag of allTags; track $index) {
              <tag-chip
                addable="true"
                [tag]="tag.name"
                (onClick)="onAddableClick(tag)" />
            }
          </div>
        }
      </div>
    }

    @case ('coaching') {
      <!-- VIDEO TITLE -->
      <div class="input name">
        <label for="">
          {{ 'sharing.editComponent.label.video_name' | translate }}
        </label>
        <input formControlName="title" type="text" />
      </div>

      <!-- STATUS -->
      <div class="select status">
        <span class="icon icon-arrow-right"></span>
        <label for="status">
          {{ 'sharing.editComponent.label.status' | translate }}
        </label>
        <select formControlName="status" name="status" id="">
          <option value="public">
            {{ 'settings.confidentiality.public' | translate }}
          </option>
          <option value="private">
            {{ 'settings.confidentiality.private' | translate }}
          </option>
        </select>
      </div>

      <!-- DESCRIPION -->
      <div class="text-area description">
        <label for="">
          {{ 'sharing.editComponent.label.description' | translate }}
        </label>
        <textarea formControlName="description" rows="6"></textarea>
      </div>

      <!-- EQUIPEMENT -->
      <div class="select equipment-type">
        <span class="icon icon-arrow-right"></span>
        <label for="">
          {{ 'compatibility.equipment.title' | translate }}
        </label>
        <select formControlName="equipment_type">
          <option class="placeholder" [value]="'null'">
            {{ 'sharing.editComponent.select.not_specified' | translate }}
          </option>
          <option value="home_trainer">
            {{ 'compatibility.machineType.hometrainer' | translate }}
          </option>
          <option value="treadmill">
            {{ 'compatibility.machineType.treadmill' | translate }}
          </option>
          <option value="elliptical">
            {{ 'compatibility.machineType.elliptical' | translate }}
          </option>
          <option value="rowing_machine">
            {{ 'compatibility.machineType.rowing' | translate }}
          </option>
          <option value="exercise_bike">
            {{ 'compatibility.machineType.exercice-bike' | translate }}
          </option>
        </select>
      </div>

      <!-- LANGUAGES -->
      <div class="select lang">
        <span class="icon icon-arrow-right"></span>
        <label for="">
          {{
            'coaching.interval_player.footer.language' | translate | titlecase
          }}
        </label>
        <select formControlName="lang" name="" id="">
          <option class="placeholder" [value]="'null'">
            {{ 'sharing.editComponent.select.not_specified' | translate }}
          </option>
          @for (lang of langs; track $index) {
            <option [value]="lang.id">
              {{ lang.native_name }} - {{ lang.name }}
            </option>
          }
        </select>
      </div>
    }

    @case ('mapmode') {
      <!-- VIDEO TITLE -->
      <div class="input name">
        <label for="">
          {{ 'sharing.editComponent.label.video_name' | translate }}
        </label>
        <input formControlName="title" type="text" />
      </div>

      <!-- STATUS -->
      <div class="select status">
        <span class="icon icon-arrow-right"></span>
        <label for="status">
          {{ 'sharing.editComponent.label.status' | translate }}
        </label>
        <select formControlName="status" name="status" id="">
          <option value="public">
            {{ 'settings.confidentiality.public' | translate }}
          </option>
          <option value="private">
            {{ 'settings.confidentiality.private' | translate }}
          </option>
        </select>
      </div>

      <!-- DESCRIPION -->
      <div class="text-area description">
        <label for="">
          {{ 'sharing.editComponent.label.description' | translate }}
        </label>
        <textarea formControlName="description" rows="6"></textarea>
      </div>
    }

    @case ('workout') {
      <!-- VIDEO TITLE -->
      <div class="input name">
        <label for="">
          {{ 'sharing.editComponent.label.video_name' | translate }}
        </label>
        <input formControlName="title" type="text" />
      </div>

      <!-- STATUS -->
      <div class="select status">
        <span class="icon icon-arrow-right"></span>
        <label for="status">
          {{ 'sharing.editComponent.label.status' | translate }}
        </label>
        <select formControlName="status" name="status" id="">
          <option value="public">
            {{ 'settings.confidentiality.public' | translate }}
          </option>
          <option value="private">
            {{ 'settings.confidentiality.private' | translate }}
          </option>
        </select>
      </div>

      <!-- DESCRIPION -->
      <div class="text-area description">
        <label for="">
          {{ 'sharing.editComponent.label.description' | translate }}
        </label>
        <textarea formControlName="description" rows="6"></textarea>
      </div>
    }
  }

  <!-- BUTTON  -->
  <kin-btn
    extended="true"
    class="submit-btn"
    [color]="'primary'"
    [disabled]="loading$ | async"
    [type]="'submit'">
    {{ 'watch.map_player.sync_btn_save' | translate | titlecase }}
  </kin-btn>

  <kin-btn
    extended="true"
    class="submit-cancel"
    (onClick)="cancelForm($event)"
    [color]="'secondary'"
    [disabled]="loading$ | async">
    {{ 'watch.map_player.sync_btn_cancel' | translate | titlecase }}
  </kin-btn>
</form>
